import React from 'react';

class Item extends React.Component {
  getDate(date) {
    date = new Date(date);
    return `${(date.getDate()<10?'0'+date.getDate():date.getDate())}/${(date.getMonth()<9?'0'+(date.getMonth()+1):date.getMonth()+1)}/${date.getFullYear()}`
  }

  getHour(date) {
    date = new Date(date);
    return `${(date.getHours()<10?'0'+date.getHours():date.getHours())}:${(date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes())}`
  }

  getValue(data) {
    return `R$ ${(data.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}))}`;
  }

  onChanged(index) {
    let list = this.props.list;
    list[index].selected = !list[index].selected;
    if(!list[index].selected)
      this.props.onChanged('allSelected', false);
    this.props.onChanged('list', list);
  }

  allOnChanged() {
    let that = this;
    let allSelected = !this.props.allSelected;
    this.props.onChanged('allSelected', allSelected);
    let list = that.props.list;
    for(let i=0; i<list.length; i++)
      list[i].selected = allSelected;
    that.props.onChanged('list', list);
  }

  render() {
   return (
     <section id="TableComponent">
       <span className="desktop">
         <table>
          <thead>
            <tr>

              {
                this.props.status === "Aberta" &&
                <th style={{borderRadius: "8px 0px 0px 8px"}}>
                  <input type="checkbox" style={{accentColor: "#54E046"}} id="scales" name="scales" checked={this.props.allSelected} onChange={()=>{this.allOnChanged()}} />
                </th>
              }
              <th style={(this.props.status === "Aberta"?{}:{borderRadius: "8px 0px 0px 8px"})}>ID</th>
              <th>Criação</th>
              {
                this.props.status !== "Aberta" &&
                <th>Trader</th>
              }
              {
                this.props.type === "geral" &&
                <th>Cliente</th>
              }
              <th>Provedor</th>
              <th>Transação</th>
              <th>Ativo</th>
              <th>Preço unitário</th>
              <th>Qtde</th>
              <th style={{borderRadius: "0px 8px 8px 0px"}}>Total da ordem</th>
            </tr>
          </thead>
          {
            this.props.list &&
            <tbody>
              {
                this.props.list.map((item, index) => {
                  return <tr key={index} style={{cursor: "pointer"}} className="itemTable">
                    {
                      this.props.status === "Aberta" &&
                      <td style={{borderRadius: "8px 0px 0px 8px", textAlign: "center"}}>
                        <input type="checkbox" style={{accentColor: "#54E046"}} id="scales" name="scales" checked={item.selected} onChange={()=>{this.onChanged(index)}} />
                      </td>
                    }
                    <td style={(this.props.status === "Aberta"?{fontSize: "14px"}:{borderRadius: "8px 0px 0px 8px", textAlign: "center", fontSize: "14px"})}>
                      <b>{item.id}</b>
                    </td>
                    <td style={{fontSize: "14px"}}>
                      {this.getDate(item.data)}<br/>
                      {this.getHour(item.data)}
                    </td>
                    {
                      this.props.status !== "Aberta" &&
                      <td style={{fontSize: "14px"}}>
                        <b>{"SAMUEL PEIXOTO"}</b>
                      </td>
                    }
                    {
                      this.props.type === "geral" &&
                      item.player !== undefined &&
                      <td style={{fontSize: "14px"}}>
                        <b>{item.player.nome}</b><br/>
                        {item.player.cnpj}<br/>
                      </td>
                    }
                    {
                      this.props.type === "geral" &&
                      item.player === undefined &&
                      <td style={{fontSize: "14px"}}>
                        <b>-</b><br/>
                        -<br/>
                      </td>
                    }
                    <td style={{fontSize: "14px"}}>
                      <b>{item.provedor.nome}</b><br/>
                      {item.provedor.codigo}<br/>
                    </td>
                    <td>
                      <b>
                        {
                            item.transaction === "Compra" &&
                            <span>
                              <img src={require("../../assets/imgs/ico-compra.svg").default} alt="Icone Status" style={{display: "inline-block"}} />
                              &nbsp;Compra
                            </span>
                        }
                        {
                            item.transaction !== "Compra" &&
                            <span>
                              <img src={require("../../assets/imgs/ico-venda.svg").default} alt="Icone Status" style={{display: "inline-block"}}/>
                              &nbsp;Venda
                            </span>
                        }
                      </b>
                    </td>
                    <td>
                      <b>
                        {
                            item.ticker === "USDC" &&
                            <span>
                              <img src={require("../../assets/imgs/USDC.svg").default} alt="Icone Status" style={{display: "inline-block"}}/>
                              &nbsp;{item.ticker}
                            </span>
                        }
                        {
                            item.ticker === "USDT" &&
                            <span>
                              <img src={require("../../assets/imgs/USDT.svg").default} alt="Icone Status" style={{display: "inline-block"}}/>
                              &nbsp;{item.ticker}
                            </span>
                        }
                        {
                            item.ticker !== "USDT" && item.ticker !== "USDC" &&
                            <span>
                              &nbsp;{item.ticker}
                            </span>
                        }
                      </b>
                    </td>
                    <td>
                      {this.getValue(item.precoUnitario)}
                    </td>
                    <td>
                      {item.quantidade}
                    </td>
                    <td style={{borderRadius: "0px 8px 8px 0px"}}>
                      <b>{this.getValue(item.valor)}</b>
                    </td>
                  </tr>
                })
              }
            </tbody>
          }
        </table>
      </span>


      <span className="mobile">
         <div style={{width: "95vw", overflowX: "scroll", height: "auto"}}>
           <table>
            <thead>
              <tr>
                {
                  this.props.status === "Aberta" &&
                  <th style={{borderRadius: "8px 0px 0px 8px"}}>
                    <input type="checkbox" id="scales" style={{accentColor: "#54E046"}} name="scales" checked={this.props.allSelected} onChange={()=>{this.allOnChanged()}} />
                  </th>
                }
                <th style={(this.props.status === "Aberta"?{}:{borderRadius: "8px 0px 0px 8px"})}>ID</th>
                <th>Criação</th>
                {
                  this.props.status !== "Aberta" &&
                  <th>Trader</th>
                }
                {
                  this.props.type === "geral" &&
                  <th>Cliente</th>
                }
                <th>Provedor</th>
                <th>Transação</th>
                <th>Ativo</th>
                <th>Preço unitário</th>
                <th>Qtde</th>
                <th style={{borderRadius: "0px 8px 8px 0px"}}>Total da ordem</th>
              </tr>
            </thead>
            {
              this.props.list &&
              <tbody>
                {
                  this.props.list.map((item, index) => {
                    return <tr key={index} style={{cursor: "pointer"}} className="itemTable">
                      {
                        this.props.status === "Aberta" &&
                        <td style={{borderRadius: "8px 0px 0px 8px", textAlign: "center"}}>
                          <input type="checkbox" style={{accentColor: "#54E046"}} id="scales" name="scales" checked={item.selected} onChange={()=>{this.onChanged(index)}} />
                        </td>
                      }
                      <td style={(this.props.status === "Aberta"?{fontSize: "14px"}:{borderRadius: "8px 0px 0px 8px", textAlign: "center", fontSize: "14px"})}>
                        <b>{item.id}</b>
                      </td>
                      <td style={{fontSize: "14px"}}>
                        {this.getDate(item.data)}<br/>
                        {this.getHour(item.data)}
                      </td>
                      {
                        this.props.status !== "Aberta" &&
                        <td style={{fontSize: "14px"}}>
                          <b>{"SAMUEL PEIXOTO"}</b>
                        </td>
                      }
                      {
                        this.props.type === "geral" &&
                        item.player !== undefined &&
                        <td style={{fontSize: "14px"}}>
                          <b>{item.player.nome}</b><br/>
                          {item.player.cnpj}<br/>
                        </td>
                      }
                      {
                        this.props.type === "geral" &&
                        item.player === undefined &&
                        <td style={{fontSize: "14px"}}>
                          <b>-</b><br/>
                          -<br/>
                        </td>
                      }
                      <td>
                        <b>{item.provedor.nome}</b><br/>
                        {item.provedor.cnpj}<br/>
                      </td>
                      <td>
                        <b>
                          {
                              item.transaction === "Compra" &&
                              <span>
                                <img src={require("../../assets/imgs/ico-compra.svg").default} alt="Icone Status" style={{display: "inline-block"}} />
                                &nbsp;Compra
                              </span>
                          }
                          {
                              item.transaction !== "Compra" &&
                              <span>
                                <img src={require("../../assets/imgs/ico-venda.svg").default} alt="Icone Status" style={{display: "inline-block"}}/>
                                &nbsp;Venda
                              </span>
                          }
                        </b>
                      </td>
                      <td>
                        <b>
                          {
                              item.ticker === "USDC" &&
                              <span>
                                <img src={require("../../assets/imgs/USDC.svg").default} alt="Icone Status" style={{display: "inline-block"}}/>
                                &nbsp;{item.ticker}
                              </span>
                          }
                          {
                              item.ticker === "USDT" &&
                              <span>
                                <img src={require("../../assets/imgs/USDT.svg").default} alt="Icone Status" style={{display: "inline-block"}}/>
                                &nbsp;{item.ticker}
                              </span>
                          }
                          {
                              item.ticker !== "USDT" && item.ticker !== "USDC" &&
                              <span>
                                &nbsp;{item.ticker}
                              </span>
                          }
                        </b>
                      </td>
                      <td>
                        {this.getValue(item.precoUnitario)}
                      </td>
                      <td>
                        {item.quantidade}
                      </td>
                      <td style={{borderRadius: "0px 8px 8px 0px"}}>
                        <b>{this.getValue(item.valor)}</b>
                      </td>
                    </tr>
                  })
                }
              </tbody>
            }
          </table>
        </div>
      </span>
    </section>
  )}
}

export default Item;
